import { useState, useEffect, useRef, useCallback } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Tooltip, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { Icon as Iconify } from '@iconify/react';
import { CcTitle, CcCreateNewButton, CcActionButton } from '../commonComponents/styledTexts';
import axios from 'axios';
import { ccColorTeal, ccColorDarkTeal, ccColorLightTeal, ccColorYellow, ccColorSecondaryPink } from '../components/helpersStyles';
import CCAutocompleteSearch from '../commonComponents/ccAutocompleteSearch';
import { lionIcons } from '../components/helpersIcons';
import { InputText } from '../commonComponents/inputFields';
import { Fragment } from "react";
import { Menu, MenuButton, MenuItems, MenuItem, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import {CcHeatmapCalendar, CcDaysOfWeekReport, CcTimeOfDayReport} from '../commonComponents/ccApollodoroReports';
import dayjs from "dayjs";

import Prism from "prismjs";
//import "prismjs/themes/prism-tomorrow.css"; // You can change the theme
//import "prism-themes/themes/prism-a11y-dark.css"
import "prism-themes/themes/prism-atom-dark.css"
//import "prism-themes/themes/prism-material-oceanic.css"

import "prismjs/components/prism-markup"; // HTML support
import {PercentageBulletChart, HorizontalStackedBarChart} from '../commonComponents/ccBulletCharts';
import { Word, WordCloud, AnimatedWordRenderer, DefaultTooltipRenderer } from "@isoterik/react-word-cloud";

import { ResponsivePie } from "@nivo/pie";
import { render } from '@testing-library/react';

const SpecialFiltersDropdown = (props) => {
  const filters = [
    { id: 'none', name: "Select one", description: "" },
    { id: 'firstEmail', name: "First Email", description: "View the first email we ever received. This is normally the start of the brand's Welcome Program" },
    { id: 'gif', name: "Gif", description: "View emails containing animated images" },
    { id: 'timers', name: "Timers", description: "Get inspired with new timers designs" }
  ];
  const [selected, setSelected] = useState(filters[0]);

  const handleSelect = (filter) => {
    setSelected(filter);
    props.onChange?.(filter);
  };

  return (
    <div className='flex flex-row'>
      <Menu as="div" className="relative inline-block text-left">
        <div>
          {/* Button shows only selected name */}
          <MenuButton className="inline-flex w-full justify-between items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-ccColorTeal focus:ring-offset-0">
            {selected.name}
            <ChevronDownIcon className="ml-2 h-5 w-5 text-gray-500" />
          </MenuButton>
        </div>

        {/* Dropdown panel */}
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <MenuItems className="absolute mt-2 w-96 origin-top-right divide-y divide-gray-200 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
            {filters.filter(f => f.id !== 'none').map((filter) => (
              <div key={filter.id} className="px-1 py-1">
                <MenuItem>
                  {({ active }) => (
                    <button
                      onClick={() => handleSelect(filter)}
                      className={`${
                        active ? "bg-ccColorTeal text-white" : "text-ccColorDarkTeal"
                      } group flex w-full flex-col rounded-md px-3 py-2 text-left text-sm`}
                    >
                      <span className="font-poppins text-lg font-semibold">{filter.name}</span>
                      <span className="text-xs text-gray-500 group-hover:text-gray-100">
                        {filter.description}
                      </span>
                    </button>
                  )}
                </MenuItem>
              </div>
            ))}
          </MenuItems>
        </Transition>
      </Menu>
      {selected.id !== 'none' && <IconButton sx={{ color: "white", padding: "6px", "&:hover": {backgroundColor: '#357e86', }}}
                                    onClick={() => handleSelect(filters[0])}
                              >
                                <Iconify width={28} icon={lionIcons.Icon_Actions_Cancel}/>
                              </IconButton>
      }
    </div>
  );
}


const CollectionsGrid = (props) => {

  /*
  props:
  productTypeId
  archive: when true it only shows archived items
  */

  const [collections, setCollections] = useState([]);
  const [dialogNewCollectionOpen, setDialogNewCollectionOpen] = useState(false);
  const [dialogData, setDialogData] = useState({action: '', id:'', title:'', desc:''});
  const [newCollectionName, setNewCollectionName] = useState('')
  const [renameId, setRenameId] = useState(0)
  const [renameCollectionName, setRenameCollectionName] = useState('')


  useEffect(() => {
    getCollections();
  }, [])


  const getCollections = useCallback(async () => {
      try {  
      let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/Collections`;

      const response = await axios.get(url);
      const data = response.data;

      setCollections(data);

      } catch (error) {
      console.log(error);
      }
  })
  const createCollection = async () => {
      try {  
      let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/Collections/create?name=${encodeURI(newCollectionName)}`;

      const response = await axios.get(url);
      //const data = response.data;


      } catch (error) {
      console.log(error);
      }
  }
  const deleteCollection = async (id) => {
      try {  
      let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/Collections/delete?collectionId=${id}`;

      const response = await axios.get(url);
      //const data = response.data;


      } catch (error) {
      console.log(error);
      }
  }
  const renameCollection = async (id, name) => {
      try {  
      let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/Collections/rename?collectionId=${id}&name=${encodeURI(name)}`;

      const response = await axios.get(url);
      //const data = response.data;


      } catch (error) {
      console.log(error);
      }
  }

  
  const handleDialogNewCollectionOpen = () => {
    setNewCollectionName('')
    setDialogNewCollectionOpen(true)
    setDialogData({action: 'create', id:'', title:'Create a new collection', desc:'Lorem ipsum'})

  }
  const handleDialogDeleteCollectionOpen = (e, collection) => {
    e.stopPropagation()
    setDialogNewCollectionOpen(true)
    setDialogData({action: 'delete', id: collection.collectionId, title:'Delete collection', desc:<><div>Are you sure you want to delete the collection <span className='font-semibold'>{collection.collectionName}</span>?</div><div>All data will be lost</div></>})
  }

  const handleDialogClose = async (action) => {
    if (action === 'create') {
      await createCollection()
      getCollections()
    }
    else if (action === 'delete') {
      await deleteCollection(dialogData.id)
      getCollections()
    }

    setDialogNewCollectionOpen(false)
  }

  const handleCollectionClick = (collection) => {
    if (props.onChange) props.onChange(collection)
  }
const handleRenameCollection = (e, collection) => {
  e.stopPropagation()
  setRenameCollectionName(collection.collectionName)
  setRenameId(collection.collectionId)
}
const handleRenameCollectionCancel = (e) => {
  e.stopPropagation()
  setRenameCollectionName('')
  setRenameId(0)
}
const handleRenameCollectionDo = async (e) => {
  e.stopPropagation()
  await renameCollection(renameId, renameCollectionName)
  setRenameId(0)
  getCollections()
}

  return <>
        <div className='flex flex-row gap-x-2 items-center mb-2'>
          <div className=' text-ccColorDarkTeal  font-poppins text-lg font-semibold '>My collections</div>
          {collections.length > 0 &&
              <div>
                <CcActionButton onClick={handleDialogNewCollectionOpen}>New collection</CcActionButton>
              </div>
          }
        </div>
      {collections.length === 0 && <div className='text-ccColorDarkTeal flex flex-row items-center gap-x-2'>
      <div className='font-poppins'>You don't have any collection yet.</div>
        <CcActionButton onClick={handleDialogNewCollectionOpen} >Create one</CcActionButton>
      </div>
    }
  {collections.length > 0 && <div className='flex flex-row'>
          <div className='max-h-72 w-[500px] overflow-auto bg-white'>
            <div className='flex flex-col text-ccColorDarkTeal font-poppins'>
              {
                collections.map((c, index) => <div className={`flex flex-row items-center gap-x-2 p-1 hover:bg-slate-100 cursor-pointer ${index > 0 ? 'border-t' : ''} ${props.selected?.collectionId === c.collectionId ? 'bg-ccColorLightTeal' : ''}`}
                  onClick={() => handleCollectionClick(c)}>
                  {renameId !== c.collectionId && <div className='w-[296px] font-semibold'>{c.collectionName}</div>}
                  {renameId === c.collectionId && <div className='w-[296px] flex flex-row gap-x-2' onClick={(e) => e.stopPropagation()}>
                      <InputText value={renameCollectionName} onChange={(val) => setRenameCollectionName(val)} />
                      <button><Iconify icon={lionIcons.Icon_Actions_TickOutlined} width={24} onClick={(e) => handleRenameCollectionDo(e)} /></button>
                      <button><Iconify icon={lionIcons.Icon_Actions_Cancel} width={24} onClick={(e) => handleRenameCollectionCancel(e)} /></button>
                  </div>}
                  <div className='text-sm bg-slate-200 p-1 rounded'>{dayjs(c.created).format('DD/MM/YYYY')}</div>
                  <div className='flex grow'></div>
                  <Tooltip title='Rename collection' placement='top'><button><Iconify icon={lionIcons.Icon_Actions_Edit} width={24} onClick={(e) => handleRenameCollection(e, c)} /></button></Tooltip>
                  <Tooltip title='Delete collection' placement='top'><button><Iconify icon={lionIcons.Icon_Actions_Delete} width={24} onClick={(e) => handleDialogDeleteCollectionOpen(e, c)} /></button></Tooltip>
                </div>)
              }
            </div>      
          </div>
        </div>
  }
      <Dialog onClose={() => handleDialogClose('abort')} open={dialogNewCollectionOpen}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description">
        <DialogTitle id="dialog-title">{dialogData.title}</DialogTitle>
        <DialogContent>
          <div className='w-[400px] mb-4'>{dialogData.desc}</div>
          {dialogData.action === 'create' &&
                <InputText displayName="Collection Name" value={newCollectionName} onChange={(val) => setNewCollectionName(val)} />
          }
          
          </DialogContent>
          <DialogActions>
            <CcActionButton onClick={() => handleDialogClose('abort')}>Cancel</CcActionButton>
            <CcActionButton onClick={() => handleDialogClose(dialogData.action)} autoFocus>
              Confirm
            </CcActionButton>
          </DialogActions>
    </Dialog>

  </>
}

const MyCollectionsSelector = (props) => {
  const [collections, setCollections] = useState([])
  const [dialogOpen, setDialogOpen] = useState(false)
  const [newCollectionName, setNewCollectionName] = useState('')

  const [selected, setSelected] = useState(undefined);

      useEffect(() => {
        getCollections();
    }, [])


    const getCollections = useCallback(async () => {
        try {  
        let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/Collections`;

        const response = await axios.get(url);
        const data = response.data;

        setCollections(data)

        } catch (error) {
        console.log(error);
        }
    })
    const createCollection = async () => {
        try {  
        let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/Collections/create?name=${encodeURI(newCollectionName)}`;

        const response = await axios.get(url);
        //const data = response.data;


        } catch (error) {
        console.log(error);
        }
    }


  const handleSelect = (e, filter) => {
    //e.stopPropagation()
    setSelected(filter);
    props.onChange?.(filter);
  };
  const handleDialogOpen = () => {

    setNewCollectionName('')
    setDialogOpen(true)
  }

  const handleDialogClose = async (action) => {
    if (action === 'create') {
      await createCollection()
      getCollections()
    }

    setDialogOpen(false)
  }

  return (
    <div className='flex flex-row'>
      <Menu as="div" className="relative inline-block text-left">
        <div className='w-[300px]'>
          {/* Button shows only selected name */}
          <MenuButton className="inline-flex w-full justify-between items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-ccColorTeal focus:ring-offset-0">
            {selected ? selected.collectionName : 'Add to a collection'}
            <ChevronDownIcon className="ml-2 h-5 w-5 text-gray-500" />
          </MenuButton>
        </div>

        {/* Dropdown panel */}
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <MenuItems className="absolute mt-2 w-96 origin-top-right divide-y divide-gray-200 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            {collections.length === 0 &&  <MenuItem>
                  {({ active }) => (
                    <button
                      onClick={handleDialogOpen}
                      className={`${
                        active ? "bg-ccColorTeal text-white" : "text-ccColorDarkTeal"
                      } group flex w-full flex-col rounded-md px-3 py-2 text-left text-sm`}
                    >
                      <span className="font-poppins text-lg font-semibold">You have no collections yet</span>
                      <div className="flex flex-row items-center gap-x-2 text-gray-500 hover:text-white">
                       <Iconify width={28} icon={lionIcons.Icon_Actions_Add}/>
                        <div>Create a new collection</div>
                      </div>
                    </button>
                  )}
                </MenuItem>
            }          
            {collections.length > 0 && collections.map((c) => (
              <div key={c.collectionId} className="px-1 py-1">
                <MenuItem>
                  {({ active }) => (
                    <button
                      onClick={(e) => handleSelect(e, c)}
                      className={`${
                        active ? "bg-ccColorTeal text-white" : "text-ccColorDarkTeal"
                      } group flex w-full flex-col rounded-md px-3 py-2 text-left text-sm`}
                    >
                      <span className="font-poppins text-lg font-semibold">{c.collectionName}</span>
                    </button>
                  )}
                </MenuItem>
              </div>
            ))}
          </MenuItems>
        </Transition>
      </Menu>
      {selected && <IconButton sx={{ color: "white", padding: "6px", "&:hover": {backgroundColor: '#357e86', }}}
                                    onClick={() => handleSelect(undefined)}
                              >
                                <Iconify width={28} icon={lionIcons.Icon_Actions_Cancel}/>
                              </IconButton>
      }
      <IconButton sx={{ color: "white", padding: "6px", "&:hover": {
                                                                    backgroundColor: ccColorLightTeal,
                                                                    //color: "darkblue",
                                                                    }
                      }}
                  onClick={handleDialogOpen}
      ><Iconify width={28} icon={lionIcons.Icon_Actions_Add}/></IconButton>

      <Dialog onClose={() => handleDialogClose('abort')} open={dialogOpen}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description">
        <DialogTitle id="dialog-title">Create a new collection</DialogTitle>
        <DialogContent>
          <div className='w-[400px] mb-4'>Lorem ipsum</div>
          <InputText displayName="Collection Name" value={newCollectionName} onChange={(val) => setNewCollectionName(val)} />
          
          </DialogContent>
          <DialogActions>
            <CcActionButton onClick={() => handleDialogClose('abort')}>Cancel</CcActionButton>
            <CcActionButton onClick={() => handleDialogClose('create')} autoFocus>
              Confirm
            </CcActionButton>
          </DialogActions>
    </Dialog>

    </div>
  );
}

const PageHeaderSelector = (props) => {
  // 3 values for selected: emailGallery, collections and brandAnalysis

  const handleClick = (mode) => {
    if (props.onChange) props.onChange(mode)
  }

  return     <div class="inline-flex rounded-md shadow-sm font-poppins" role="group">
      <div className={`cursor-pointer px-4 py-2 w-80 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-s-lg hover:bg-gray-100 hover:text-ccColorTeal ${props.selected === 'emailGallery' ? 'bg-gray-200' : 'bg-white'}`}
            onClick={()=>handleClick('emailGallery')}>
        <div className='text-lg'>
          Get inspired
        </div>
        <div className='text-sm mt-2 font-normal'>Browse emails as soon as we receive them. </div>
      </div>
      <div className={`cursor-pointer px-4 py-2 w-80 font-medium border-t border-b border-gray-200 focus:outline-none focus:ring-0 hover:bg-gray-100 hover:text-ccColorTeal ${props.selected === 'collections' ? 'bg-gray-200' : 'bg-white'}`}
          onClick={()=>handleClick('collections')}>
        <div className='text-lg'>
          My collections
        </div>
        <div className='text-sm mt-2 font-normal'>Keep track of your favourite emails by organising them in collections.</div>
      </div>
      <div className={`cursor-pointer px-4 py-2 w-80 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-e-lg hover:bg-gray-100 hover:text-ccColorTeal ${props.selected === 'brandAnalysis' ? 'bg-gray-200' : 'bg-white'}`}
          onClick={()=>handleClick('brandAnalysis')}>
        <div className='text-lg'>
          Brand Analysis
        </div>
        <div className='text-sm mt-2 font-normal'>View reports and trends specific by brand</div>
      </div>
    </div>
  
}

const EmailGallery = (props) => {
    /*
    props:
    productTypeId: show templates of a specific type
    selectedTemplateId: 
    */
    const maxId = 999999999
    const [emails, setEmails] = useState([]);
    const [lastId, setLastId] = useState(maxId);
    const [selectedBrand, setSelectedBrand] = useState(undefined);
    const [selectedSpecialFilter, setSelectedSpecialFilter] = useState(undefined);
    const [selectedCollection, setSelectedCollection] = useState(undefined);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const observerRef = useRef();
    const [emailIdOver, setEmailIdOver] = useState(undefined);
    const [emailIdOverShowAddToCollections, setEmailIdOverShowAddToCollections] = useState(false);

    //const [selectedEmailId, setSelectedEmailId] = useState(0);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogData, setDialogData] = useState({action: '', id:'', title:'', desc:''});


    useEffect(() => {
        if (props.collectionsMode == null) getEmails();
    }, [])


    const getEmails = useCallback(async (settings) => {
        let _lastId = lastId;
        let _brandId = selectedBrand?.brandId;
        let _specialFilter = selectedSpecialFilter?.id;
        let _collectionId = selectedCollection?.id;
        if (settings) {
          if (settings.lastId) _lastId = settings.lastId
          _brandId = settings.brandId
          if (settings.specialFilter) _specialFilter = settings.specialFilter
          _collectionId = settings.collectionId
        }

        try {  
        let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/Recents?lastId=${_lastId}&specialFilter=${_specialFilter}`;
        if (_brandId) url += `&brandId=${_brandId}`;
        if (_collectionId) url += `&collectionId=${_collectionId}`;

        const response = await axios.get(url);
        const data = response.data;

        const lastEmail = data[data.length -1]
        
        setLastId(lastEmail.emailId); // update cursor
        //setHasMore(data.hasMore);
        const cleanEmails = data.map(d => {d.imgUrl = `${process.env.REACT_APP_LION_API_URL}/${d.imgUrl}`
                                    return d})
        setEmails((prev) => [...prev, ...cleanEmails]);
        //console.log(cleanEmails.length === 10)
        setHasMore(cleanEmails.length === 10)



        } catch (error) {
        console.log(error);
        }
    })
    const collectionAddEmail = async (collectionId, emailId) => {
        try {  
        let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/Collections/addEmail?emailId=${emailId}&collectionId=${collectionId}`;

        const response = await axios.get(url);


        } catch (error) {
        console.log(error);
        }
    }
    const collectionRemoveEmail = async (collectionId, emailId) => {
        try {  
        let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/Collections/removeEmail?emailId=${emailId}&collectionId=${collectionId}`;

        const response = await axios.get(url);


        } catch (error) {
        console.log(error);
        }
    }

    const handleOnclick = (emailId) => {
        //this gets clicked also when you add an email to a collection
        //in this case we don't want to bubble up the event
        if (emailIdOverShowAddToCollections) return

        if (props.onClick) props.onClick(emailId)
    }
    
    const lastItemRef = useCallback(
    (node) => {
      if (loading) return;
      if (observerRef.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          getEmails();
        }
      });

      if (node) observerRef.current.observe(node);
    },
    [loading, hasMore, getEmails]
  );

  const handleSelectedBrandChange = (brandInfo) => {
    if (brandInfo == null) return
    setSelectedBrand(brandInfo)
    setLastId(maxId)
    const settings = {brandId: brandInfo.brandId, lastId: maxId, specialFilter: selectedSpecialFilter?.id}
    setEmails([])
    setLastId(maxId)
    getEmails(settings)
  }
  const handleClearSelectedBrand = () => {
    setSelectedBrand(undefined)
    setEmails([])
    const settings = {brandId: undefined, lastId: maxId, specialFilter: selectedSpecialFilter?.id}
    setLastId(maxId)
    getEmails(settings)
  }
  const handleSpecialFilterChange = (filter) => {
    setSelectedSpecialFilter(filter)
    const settings = {brandId: selectedBrand?.brandId, lastId: maxId, specialFilter: filter.id, collectionId: undefined}
    setEmails([])
    setLastId(maxId)
    getEmails(settings)

  }
  const handleCollectionFilterChange = (collection) => {
    setSelectedBrand(undefined)
    setSelectedCollection(collection)
    const collectionId = collection?.collectionId
    const settings = {brandId: undefined, lastId: maxId, specialFilter: undefined, collectionId: collectionId}
    //console.log(settings)
    setEmails([])
    setLastId(maxId)
    getEmails(settings)

  }
  const handleAddToCollection = (event, emailId) => {
    //event.stopPropagation()
    setEmailIdOverShowAddToCollections(true)
  }
  const handleAddToCollectionDo = (collection) => {
    const collectionId = collection.collectionId
    const emailId = emailIdOver
    collectionAddEmail(collectionId, emailId)
    setEmailIdOverShowAddToCollections(false)
    setEmailIdOver(undefined)

  }
  const handleRemoveFromCollection = async (emailId) => {
    await collectionRemoveEmail(selectedCollection.collectionId, emailId)
    //refreshing the gallery
    handleCollectionFilterChange(selectedCollection)
  }

    return <div>
                {props.collectionsMode == null &&
                <div className='flex flex-row gap-x-4 items-center'>
                  {selectedBrand ?
                      <div className='flex flex-row items-center gap-x-2 bg-ccColorLightTeal rounded px-2 py-1 w-fit font-poppins'>
                        <div className='text-ccColorDarkTeal'>{selectedBrand.brandName}</div>
                        <IconButton sx={{ color: "white", padding: "6px", "&:hover": {
                                                                                      backgroundColor: '#357e86',
                                                                                      //color: "darkblue",
                                                                                      }
                                        }}
                                    onClick={handleClearSelectedBrand}
                        ><Iconify width={28} icon={lionIcons.Icon_Actions_Cancel}/></IconButton>
                      </div>
                    :
                      <CCAutocompleteSearch url={`${process.env.REACT_APP_LION_API_URL}/Apollodoro/Brand/searchSuggestions`} 
                        placeHolder="Search a brand"
                        onChange={handleSelectedBrandChange}
                      />
                  }
                  <div className='flex flex-row items-center gap-x-2 bg-ccColorYellow rounded px-2 py-1'>
                    <div className=' text-ccColorDarkTeal  font-poppins text-sm font-semibold '>Specials</div>
                    <SpecialFiltersDropdown onChange={handleSpecialFilterChange} />
                  </div>

                  
                </div>                
                }
                {props.collectionsMode && <div className='flex flex-col gap-x-2 rounded px-2 py-1'>
                    <CollectionsGrid onChange={handleCollectionFilterChange}
                        selected={selectedCollection}
                    />

                  </div>

                }
                <div className='mt-2 grid grid-cols-3 gap-x-1 gap-y-12'>
                    {emails.map(e => <div className='relative flex flex-col gap-0 w-[350px] bg-white cursor-pointer hover:border-ccColorLightTeal hover:border-2 '
                                       //onClick={() => handleOnclick(e.emailId)}
                                       onMouseEnter={()=> setEmailIdOver(e.emailId)}
                                       onMouseLeave={()=> {setEmailIdOver(undefined); setEmailIdOverShowAddToCollections(false)}}
                                       ref={lastItemRef} >
                                <div className='px-1 font-bold'>{e.fromDisplayName}</div>
                                <div className='px-1 text-slate-400'>{e.receivedPretty}</div>
                                <img className='w-[350px] h-auto ' src={e.imgUrl} />

                                <div className='py-4 px-1 text-ccColorDarkTeal font-poppins font-bold'>{e.subject}</div>
                                <div className='px-1 text-slate-400 font-roboto'>{e.preheader}</div>
                                {emailIdOver === e.emailId && <div className='absolute left-[348px] -top-[2px] '>
                                  {emailIdOverShowAddToCollections ? <div className=''>
                                    <MyCollectionsSelector onChange={handleAddToCollectionDo} />
                                    </div>
                                    :
                                    <div className='flex flex-col'>
                                      {props.collectionsMode ?
                                      <button className='bg-ccColorLightTeal text-ccColorDarkTeal p-1 hover:text-ccColorYellow hover:bg-ccColorTeal'
                                            onClick={() => handleRemoveFromCollection(e.emailId)}
                                      >
                                      <Iconify icon={lionIcons.Icon_Actions_Delete} width={32} />
                                    </button>
                                    :
                                    <button className='bg-ccColorLightTeal text-ccColorOrange p-1 hover:text-ccColorYellow hover:bg-ccColorTeal'
                                            onClick={(event) => handleAddToCollection(event, e.emailId)}
                                      >
                                      <Iconify icon={lionIcons.Icon_Shapes_Star_Filled} width={32} />
                                    </button>
                                    }
                                    <button className='border-t-[2px] border-ccColorDarkTeal bg-ccColorLightTeal text-ccColorSecondaryPurple p-1 hover:text-ccColorYellow hover:bg-ccColorTeal'
                                            onClick={() => handleOnclick(e.emailId)}
                                      >
                                      <Iconify icon={lionIcons.Icon_Reports} width={32} />
                                    </button>
                                  </div>
                                  }
                                  </div>}
                            </div>
                    )}
                </div>
    </div>
    }  

export const CodeViewer = ({ code }) => {
  const codeRef = useRef(null);
  const preRef = useRef(null);

  useEffect(() => {
    Prism.highlightElement(codeRef.current);
  }, [code]); // re-highlight whenever code changes

useEffect(() => {
    const pre = preRef.current;
    const code = codeRef.current;
    if (!pre || !code) return;

    const handleClick = () => pre.focus();

    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "a") {
        if (document.activeElement === pre) {
          e.preventDefault();

          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(code);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
    };

    pre.addEventListener("click", handleClick);
    pre.addEventListener("keydown", handleKeyDown);

    return () => {
      pre.removeEventListener("click", handleClick);
      pre.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  
  return (
    <div
      style={{
        height: "100%",
        overflow: "auto",
        border: "1px solid #ccc",
        borderRadius: "4px",
      }}
    >
      <pre style={{ margin: 0 }}
          ref={preRef}
          tabIndex={0} // Makes it focusable so it can receive key events
      >
        <code ref={codeRef} className="language-html">
          {code}
        </code>
      </pre>
    </div>
  );
};
const WordCloudCustomTooltip = (props) => {

  const animatedWordRenderer = (data, ref) => (
  <AnimatedWordRenderer ref={ref} data={data} animationDelay={(_word, index) => index * 50} />
  );

const tooltipRef = useRef(null);

  useEffect(() => {
    // Create tooltip div once
    const tooltip = document.createElement("div");
    tooltip.style.position = "fixed";
    tooltip.style.pointerEvents = "none";
    tooltip.style.background = "#000";
    tooltip.style.color = "#fff";
    tooltip.style.padding = "8px 12px";
    tooltip.style.borderRadius = "8px";
    tooltip.style.fontFamily = "Arial";
    tooltip.style.fontSize = "14px";
    tooltip.style.whiteSpace = "nowrap";
    tooltip.style.display = "none"; // hidden initially
    tooltip.style.zIndex = 9999;
    document.body.appendChild(tooltip);
    tooltipRef.current = tooltip;

    return () => {
      document.body.removeChild(tooltip);
    };
  }, []);

  const handleMouseOver = (word, index, event) => {
    if (!tooltipRef.current) return;
    const tooltip = tooltipRef.current;
    tooltip.innerHTML = `<strong>${word.text}</strong><br/>${word.value /100} occurencies`;
    tooltip.style.display = "block";
    tooltip.style.left = event.clientX + 10 + "px";
    tooltip.style.top = event.clientY + 10 + "px";
    tooltip.style.background = `${word.fill || "#333"}BF`

  };


  const handleMouseOut = () => {
    if (!tooltipRef.current) return;
    tooltipRef.current.style.display = "none";
  };


  return <div className='w-full h-[300px] relative'>
      <WordCloud words={props.words} width={400} height={300}
      renderWord={animatedWordRenderer}
      onWordMouseOver={handleMouseOver}
        onWordMouseOut={handleMouseOut}
       />
    
    </div>
}

const EmailStatsViewer = (props) => {
  const [emailStats, setEmailStats] = useState(undefined);
  const [words, setWords] = useState(undefined)

  useEffect(() => {
    if (props.emailId) getEmailStats(props.emailId)
  }, [props.emailId])

  const extractWords = (text) => {
    text = text.replace(/[^\x20-\x7E]+/g, ' ');

    // Split the text by any whitespace (spaces, tabs, newlines)
    let words = text.split(/\s+/);

    // Filter out empty strings
    words = words.filter(word => word.length > 0);
    const wordOccurenciesDic = {}
    for (const word of words) {
      const wordNormalized = word.toLowerCase();
      if (!wordOccurenciesDic[wordNormalized]) wordOccurenciesDic[wordNormalized] = 0

      wordOccurenciesDic[wordNormalized] += 1;
    }
    const keys = Object.keys(wordOccurenciesDic);
    const result = new Array();

    keys.forEach(key => {
      result.push({text: key, value: wordOccurenciesDic[key] * 100})
    })
    //console.log(result)
    //const sortedResult = result.sort((a, b) => b.value - a.value);
    //console.log(sortedResult.slice(0, 50))
    setWords(result)
  }


  const getEmailStats = async (id) => {
    try {  
    let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/EmailStats/${id}`;
    
    const response = await axios.get(url);
    const stats = response.data;
    setEmailStats(stats)
    extractWords(stats.htmlText)
    //console.log(html)

    } catch (error) {
    console.log(error);
    }
  }
  const getPercentagePretty = (val, numDecimals) => {
    let result = val * 100 * Math.pow(10, numDecimals)
    result = parseInt(result)
    result = result / Math.pow(10, numDecimals)

    return result
  }

  const DisplayInfo = () => {
    if (props.emailInfo) return <div className='flex flex-col gap-y-1'>
      <div className='flex flex-row items-center gap-x-2 text-ccColorDarkTeal'>
        <div className='bg-slate-200 rounded px-2 py-1'>From</div>
        <div className='font-poppins font-semibold text-lg'>{props.emailInfo.fromDisplayName}</div>
        <div className='flex grow max-w-[100px]'></div>
        <Iconify icon={lionIcons.Icon_Calendar} width={28} />
        <div className='font-poppins text-slate-500'>{dayjs(props.emailInfo.received).format('DD/MM/YYYY HH:mm')}</div>
      </div>
      <div className='flex flex-row items-center gap-x-2 text-ccColorDarkTeal'>
        <Iconify icon="mdi:email-outline" width={32} />
        <div className='font-poppins'>{props.emailInfo.fromEmail}</div>
      </div>
      <div className='flex flex-row items-center gap-x-2 text-ccColorOrange'>
        <div className='bg-slate-200 rounded px-2 py-1'>Subject</div>
        <div className='font-poppins font-semibold text-lg'>{props.emailInfo.subject}</div>
      </div>
      <div className='flex flex-row items-center gap-x-2 text-slate-600'>
        <div className='bg-slate-200 rounded px-2 py-1'>Preheader</div>
        <div className='font-poppins'>{props.emailInfo.preheader}</div>
      </div>

    </div>
  }

  const DisplayStats = () => {
    if (emailStats) return <div className='flex flex-col gap-y-1 font-poppins'>

{emailStats.imageToTextRatio > 0 &&
        <div className='bg-slate-200 mt-2 rounded'>
          <div className='flex flex-row text-ccColorSecondaryPurple items-center gap-x-1 px-2 py-1'>
            <div className=' '>Image to Text Ratio</div>
            <div className='font-poppins font-semibold'>{getPercentagePretty(emailStats.imageToTextRatio, 2)}%</div>
          </div>
          <PercentageBulletChart value={getPercentagePretty(emailStats.imageToTextRatio, 0)} />
        </div>
  }
  {console.log(emailStats)}
  <div className='mt-2'>
    <div>Image vs Text links</div>
    <HorizontalStackedBarChart numImageLinks={emailStats.imageLinks} numTextLink={emailStats.textLinks} />

  </div>

  {emailStats.prominentText?.length > 0 &&
        <div className='flex flex-row items-start gap-x-2 text-slate-600'>
          <div className='bg-slate-200 rounded px-2 py-1 mt-1'><div className='w-[120px]'>Prominent text</div></div>
          <div className='flex items-center font-poppins min-h-9'>{emailStats.prominentText}</div>
        </div>
  }
    </div>
  }

  return <div>
    <DisplayInfo />
    <DisplayStats />
    {words && <div className='mt-2'> <WordCloudCustomTooltip words={words} /></div>}
    
  </div>
}

const EmailViewer = ({ html }) => {
  const iframeRef = useRef(null);
  const [darkMode, setDarkMode] = useState(false);
  const [viewMode, setViewMode] = useState('preview');


  useEffect(() => {
    if (iframeRef.current) {
      const iframe = iframeRef.current;
      const doc = iframe.contentDocument || iframe.contentWindow.document;

      // Construct HTML with JS override for prefers-color-scheme
      const overrideScript = `
        <script>
          (function() {
            const dark = ${darkMode};

            window.matchMedia = function(query) {
              return {
                matches: query === '(prefers-color-scheme: ' + (dark ? 'dark' : 'light') + ')',
                media: query,
                onchange: null,
                addListener: function() {},
                removeListener: function() {}
              };
            };
          })();
        </script>
      `;

      doc.open();
      doc.write(`
        <html>
          <head>
            ${overrideScript}
          </head>
          <body>
            ${html}
          </body>
        </html>
      `);
      doc.close();
    }
  }, [html, darkMode, viewMode]);

  return (
    <div>
      <ToggleButtonGroup
          value={viewMode}
          exclusive
          onChange={(e, newValue) => setViewMode(newValue)}
          >
          <ToggleButton value="preview" >
                  <div>Preview</div>
          </ToggleButton>
          <ToggleButton value="html" >
          <div>Source code</div>
          </ToggleButton>
      </ToggleButtonGroup>

      <div className='h-[800px]'>

      {viewMode === 'preview' &&
            <iframe
              ref={iframeRef}
              style={{ width: '100%', height: '100%', border: '1px solid #ccc', marginTop: 10 }}
              sandbox="allow-same-origin"
              title="Email Preview"
            />
      }
      {viewMode === 'html' &&
      <div className='h-[800px]'>
        <CodeViewer code={html} />
      </div>
      }
      </div>

    </div>
  );
}

const BrandViewer = (props) => {
  const [selectedLetter, setSelectedLetter] = useState()
  const [selectedBrands, setSelectedBrands] = useState([]) //contains the brands of the selectedLetter
  const [allBrandsDic, setAllBrandsDic] = useState({})
  const [brandIdOver, setBrandIdOver] = useState(undefined);

const letters = ['A','B','C','D','E','F','G','H','I','J','K','L','M',
                  'N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];

  useEffect(() => {
      handleClick(letters[0])
  }, [])
  const handleBrandSelected = (brand) => {
    if (props.onChange) props.onChange(brand)
  }

  const handleClick = async (letter) => {
    setSelectedLetter(letter)
    if (allBrandsDic[letter] === undefined) {
      const brands = await getBrandsByInitial(letter)
      setAllBrandsDic((prev) => ({...prev, [letter]: brands}))
      allBrandsDic[letter] = brands
      setSelectedBrands(brands)
    }
    else setSelectedBrands(allBrandsDic[letter])
  }

  const getBrandsByInitial = async (letter) => {
    try {  
    let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/Brand/byInitial?letter=${encodeURI(letter)}`;

    const response = await axios.get(url);
    const data = response.data;
    return data

    } catch (error) {
    console.log(error);
    }
  }
  const addBrandToFav = async (brandId) => {
  try {  
  let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/Brand/add?brandId=${brandId}`;

  const response = await axios.get(url);

  } catch (error) {
  console.log(error);
  }
}

const handleAddToWatchlist = (e, brand) => {
  console.log(brand)
  e.stopPropagation()
  addBrandToFav(brand.brandId)
  if (props.onAddedToFavourite) props.onAddedToFavourite(brand)
}


  const LetterButton = ({letter, selected}) => {
    return <button className={`${selected ? 'bg-ccColorLightTeal' : 'bg-slate-200'} w-10 py-1 text-lg rounded font-bold hover:bg-ccColorDarkTeal hover:text-white`}
                onClick={() => handleClick(letter)}
            >{letter}
            </button>
  }

  return <div> 
                <div className='flex flex-row flex-wrap gap-2 text-ccColorDarkTeal'>
                  {letters.map(l => <LetterButton letter={l} selected={l === selectedLetter} />)}
                </div>
        <div className='relative mt-2 font-poppins overflow-auto max-h-96'>
          {selectedBrands.length === 0 && <div>No brands yet</div>}
          {selectedBrands.map(b => <div className='relative w-[208px] h-[34px] px-2 py-1 cursor-pointer rounded-s hover:bg-slate-200 hover:border  hover:border-ccColorTeal'
                                       onClick={() => handleBrandSelected(b)}
                                       onMouseEnter={()=> setBrandIdOver(b.brandId)}
                                       onMouseLeave={()=> {setBrandIdOver(undefined);}}                                       
                                       >{b.brandName}
                                    {brandIdOver === b.brandId &&  <div className='absolute left-[206px] -top-[1px] h-[34px] bg-ccColorLightTeal border-ccColorTeal border rounded-r '>
                                          <button className=' text-ccColorOrange w-[32px] h-[32px] hover:text-ccColorYellow  hover:bg-ccColorTeal'
                                            onClick={(event) => handleAddToWatchlist(event, b)}
                                      >
                                      <Iconify icon={lionIcons.Icon_Shapes_Star_Filled} width={32} height={32} />
                                    </button>
                                    </div>
                                    }                                       
                                  </div>)}
        </div>
  </div>
}

const FavouriteBrandViewer = (props) => {
  const [brandIdOver, setBrandIdOver] = useState(undefined);

  const removeBrandFromFav = async (brandId) => {
    try {  
    let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/Brand/remove?brandId=${brandId}`;

    const response = await axios.get(url);

    } catch (error) {
    console.log(error);
    }
  }


  const handleBrandSelected = (brand) => {
    if (props.onChange) props.onChange(brand)
  }
  const handleRemoveFromWatchlist = (e, brand) => {
    e.stopPropagation()
    removeBrandFromFav(brand.brandId)
    if (props.onRemovedFromFavourite) props.onRemovedFromFavourite(brand)
  }



  return <div className='font-poppins overflow-auto max-h-96'>
          {props.brands.length === 0 && <div>You don't have any brands yet in your watch list</div>}
          {props.brands.map(b => <div className='relative w-[208px] h-[34px] px-2 py-1 cursor-pointer rounded-s hover:bg-slate-200 hover:border  hover:border-ccColorTeal'
                                       onClick={() => handleBrandSelected(b)}
                                       onMouseEnter={()=> setBrandIdOver(b.brandId)}
                                       onMouseLeave={()=> {setBrandIdOver(undefined);}}                                       
                                       >{b.brandName}
                                    {brandIdOver === b.brandId &&  <div className='absolute left-[206px] -top-[1px] h-[34px] bg-ccColorLightTeal border-ccColorTeal border rounded-r '>
                                          <button className=' text-ccColorOrange w-[32px] h-[32px] hover:text-ccColorYellow  hover:bg-ccColorTeal'
                                            onClick={(event) => handleRemoveFromWatchlist(event, b)}
                                      >
                                      <Iconify icon={lionIcons.Icon_Actions_Delete} width={32} height={32} />
                                    </button>
                                    </div>
                                    }                                       
                                  </div>
                                   )}
        </div>
}


const BrandAnalysisViewer = (props) => {
  const [selectedBrand, setSelectedBrand] = useState(undefined)
  const [userBrands, setUserBrands] = useState([])

  useEffect(() => {
    getUserBrands()
  }, [])

  const handleSelectedBrandChange = (brand) => {
    setSelectedBrand(brand)
  }

    const getUserBrands = async (letter) => {
    try {  
    let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/Brands`;

    const response = await axios.get(url);
    const data = response.data;
    setUserBrands(data)

    } catch (error) {
    console.log(error);
    }
}
const handleBrandAddedToFavourite = (brand) => {
  setUserBrands((prev) => {return [...userBrands, brand]})
}
const handleBrandRemovedFromFavourite = (brand) => {
  const index = userBrands.findIndex(b => b.brandId === brand.brandId)
  if (index !== -1) {
    const newUserBrands = [...userBrands]
    newUserBrands.splice(index, 1)
    setUserBrands(newUserBrands) 
  }
}

  if (selectedBrand === undefined) return <div>
      <div className='flex justify-center mt-8'>
        <div className='text-2xl text-slate-400 font-poppins'>Select a brand to start the analysis</div>
      </div>
      <div className='grid grid-cols-3 gap-x-2 mt-8'>
      <div className=''>
        <div className='font-poppins text-ccColorDarkTeal mb-2'>Start typing to search</div>
        <CCAutocompleteSearch url={`${process.env.REACT_APP_LION_API_URL}/Apollodoro/Brand/searchSuggestions`} 
          placeHolder="Search a brand"
          onChange={handleSelectedBrandChange}
        />
      </div>
      <div className=''>
        <div className='font-poppins text-ccColorDarkTeal mb-2'>Pick from all brands list</div>
        <BrandViewer onChange={handleSelectedBrandChange}
                      onAddedToFavourite={handleBrandAddedToFavourite} />
      </div>
      <div className=''>
        <div className='font-poppins text-ccColorDarkTeal mb-2'>Brands watchlist</div>
        <FavouriteBrandViewer brands={userBrands}
                   onChange={handleSelectedBrandChange}
                   onRemovedFromFavourite={handleBrandRemovedFromFavourite} />
      </div>
      </div>
    </div>
  else return <div>
              <div className='flex flex-row items-center'>
                <CcTitle>{selectedBrand.brandName}</CcTitle>
                <div className='flex grow'></div>
                <button className='text-slate-400 pb-[1px] hover:pb-0 hover:border-b ' onClick={() => setSelectedBrand(undefined)}>Select another brand</button>
              </div>
              <CcHeatmapCalendar brandId={selectedBrand?.brandId} />
              <div className='grid grid-cols-2 gap-x-4'>
                <div>
                  <div className='font-poppins text-lg text-ccColorDarkTeal font-semibold'>Send days</div>
                  <CcDaysOfWeekReport brandId={selectedBrand?.brandId} />
                </div>
                <div>
                  <div className='font-poppins text-lg text-ccColorDarkTeal font-semibold'>Send time</div>
                  <CcTimeOfDayReport brandId={selectedBrand?.brandId} />
                </div>

              </div>

        </div>
}

export default function PageApollodorus() {
  
    //mainMode is the main variable of the page which determines what you can see
    const [mainMode, setMainMode] = useState("emailGallery"); // this can be either: emailGallery, collections or brandAnalysis
    
    const [selectedEmailId, setSelectedEmailId] = useState(0);
    const [selectedHtml, setSelectedHtml] = useState("");
    const [selectedEmailInfo, setSelectedEmailInfo] = useState(undefined);
    const [emailsHtml, setEmailsHtml] = useState({}); //dictionary {emailId:, html:}

    const getEmailInfo = async (id) => {
      try {  
      let url = `${process.env.REACT_APP_LION_API_URL}/Apollodoro/EmailInfo/${id}`;
      
      const response = await axios.get(url);
      const html = response.data;
      return html
      //console.log(html)

      } catch (error) {
      console.log(error);
      }
    }


    const handleEmailSelect = async (emailId) => {
        setSelectedEmailId(emailId)
        //console.log(emailsHtml[emailId])
        if (emailsHtml[emailId]) {
          setSelectedHtml(emailsHtml[emailId].html)
          setSelectedEmailInfo(emailsHtml[emailId])
        }
        else {
          const emailInfo = await getEmailInfo(emailId)
          const newEmailDic = {...emailsHtml, [emailId]: emailInfo}
          setEmailsHtml(newEmailDic)
          setSelectedHtml(emailInfo.html)
          setSelectedEmailInfo(emailInfo)
        }

    }

    return <div>
                  <CcTitle>Apollodorus</CcTitle>
                  <div className='mt-4 flex flex-row justify-center text-ccColorDarkTeal'>
                    <PageHeaderSelector selected={mainMode} onChange={setMainMode} />                  
                  </div>
                  {mainMode === "emailGallery" && <>
                    {selectedEmailId == 0 && <>
                          <div className='mt-4 bg-slate-200 px-16 py-4'>
                              <EmailGallery onClick={handleEmailSelect} />
                          </div>
                          </>
                    }
                    {selectedEmailId > 0 &&
                    <div className='mt-4'>
                          <div className='flex justify-end'>
                              <IconButton variant="contained" sx={{'&.MuiIconButton-root': {color: ccColorTeal}}} onClick={() => setSelectedEmailId(0)} >
                                  <Iconify icon="material-symbols:cancel-outline" width="48px" />
                              </IconButton>
                          </div>
                          <div className='grid grid-cols-2 gap-x-4'>
                            <EmailViewer html={selectedHtml} />
                            <EmailStatsViewer emailId={selectedEmailId} emailInfo={selectedEmailInfo} />
                          </div>
                    </div>
                    }
                  
                  </>
                  }
                  {mainMode === "brandAnalysis" && <div className='mt-2'>
                          <BrandAnalysisViewer />
                  
                  </div>

                  }
                  {mainMode === "collections" && <>
                          <div className='mt-4 bg-slate-200 px-16 py-4'>
                              <EmailGallery onClick={handleEmailSelect} collectionsMode />
                          </div>                  
                  </>

                  }
    </div>
}